import { Input, Spin, Tooltip } from "@arco-design/web-react"
import "./GroupList.less"
import React, { useEffect, useRef, useState } from 'react'
import { IconMenuFold, IconSearch } from "@arco-design/web-react/icon"
import fileImg from '@/assets/images/file.png'
import { getAuthAccountListApi, getAuthGroupApi } from "@/services/YsApi/auto"
import publishStore from "@/stores/publishStore"
import { Menu, Slider } from '@arco-design/web-react';
import { IconApps, IconBug, IconBulb } from '@arco-design/web-react/icon';
const MenuItem = Menu.Item;
const SubMenu = Menu.SubMenu;
export default function GroupList(props) {
  const { onChange, canVisible = true, onClickItem } = props;
  const [groupList, setGroupList] = useState([])
  const [childrenMap, setChildrenMap] = useState({}); // 存放子级数据
  const [loadingKeys, setLoadingKeys] = useState([]); // 正在加载的 groupId
  const [activeGroupId, setActiveGroupId] = useState(0)
  const [loading, setLoading] = useState(false)
  const allGroupList = useRef([])


  const onClick = (id) => {
    onChange(id)
    setActiveGroupId(id)
  }
  const handleSubMenuClick = async (groupId) => {
    if (!childrenMap[groupId] && !loadingKeys.includes(groupId)) {
      setLoadingKeys(prev => [...prev, groupId]);
      const res = await getAuthAccountListApi({
        id: groupId,
        platform: 1,
        auth_type: 1,
      }); // 请求子级
      setChildrenMap(prev => ({
        ...prev,
        [groupId]: res?.data?.accounts || []
      }));
      setLoadingKeys(prev => prev.filter(id => id !== groupId));
    }
  }
  const getList = async (keyword?) => {
    setLoading(true)
    const res = await getAuthGroupApi({
      keyword
    })
    setLoading(false)
    setGroupList(res?.data?.items || []);
  }
  useEffect(() => {
    getList()
  }, [])
  return (
    <div className="message-group-list" style={{
      display: !publishStore.groupVisible && canVisible ? 'none' : 'block',
      height: 'calc(100vh - 142px)'
    }}>
      <div className="group-title">
        {/* {canVisible &&
          <Tooltip position='right' trigger='hover' content='隐藏分组'>
            <IconMenuFold style={{ cursor: 'pointer' }} onClick={() => publishStore.updateGroupVisible(false)} />
          </Tooltip>
        } */}
      </div>
      <div>
        <Input
          allowClear
          prefix={<IconSearch />}
          placeholder={'搜索客户名称或账号'}
          onPressEnter={(e) => {
            getList(e.target.value)
          }}
        />
      </div>
      <Spin loading={loading}>
        <div className="group-list">

          <Menu
            accordion
            onClickSubMenu={(key) => {
              handleSubMenuClick(key)
            }}
            style={{ height: 'calc(100vh - 155px)', overflowY: 'auto', minWidth: 353 }}
          >
            {groupList.map((item, index) => <SubMenu key={item.id} title={item.name}>
              {!childrenMap[item.id] ? <MenuItem key="loading">
                <Spin key={index} loading={true}></Spin>
              </MenuItem> : childrenMap[item.id].length ? childrenMap[item.id].map((child, index) => (
                <MenuItem disabled={child.auth_enabled !== 1} key={`${item.id}-${child.id}`} onClick={() => {
                  onClickItem(child, item.id)
                }}>
                  <div className="menuitem-info">
                    <img src={child.avatar || ''} alt="" />
                    <div className="menuitem-text">
                      <p>{child.nickname}</p>
                    </div>
                    <div className="menuitem-status">
                      <span style={{ background: child.auth_enabled === 1 ? '#21B347' : '#FF5159' }}></span>
                      <p style={{ color: child.auth_enabled === 1 ? '#21B347' : '#FF5159' }}>{child.auth_enabled === 1 ? '已授权' : '已失效'}</p>
                    </div>
                  </div>
                </MenuItem>
              )) : <MenuItem key={`loading_${index}`}>
                <p className="no_datata">暂无数据</p>
              </MenuItem>}
            </SubMenu>)}



          </Menu>
        </div>
      </Spin >
    </div >
  )
}
